import React from "react";
import { Layout, Menu, Icon, Modal } from "antd";
import cw from "../../utils/commonwords";
import { Link } from "react-router-dom";
import { ReactComponent as PersonIcon } from "../../images/person.svg";
import DeleteIcon from "../../images/delete.svg";
import EditIcon from "../../images/edit.svg";

import styles from "./styles.module.scss";
import "./styles.scss";
import { GroupForm } from "..";
// import GrayedGroupIcon from '../../images/grayed-group.svg';

import classnames from "classnames";
import { FormattedMessage } from "react-intl";

export class Sider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      groupModalVisibile: false,
      groupFormTitle: props.intl.formatMessage(cw["CreateGroup"]),
      groupFormData: {},
      groupFormStatus: "create",
    };
  }
  componentWillReceiveProps = (newProps) => {
    if (newProps.groupCreated) {
      this.setState((state, props) => ({
        groupModalVisibile: false,
      }));
    }
  };
  handleCreateGroupButtonClick = (e, group) => {
    this.setState(
      (state, props) => ({
        groupFormData: group || {},
      }),
      () => {
        this.setState((state, props) => ({
          groupModalVisibile: true,
        }));
      }
    );
  };
  handleCloseGroupFormModal = () => {
    this.setState((state, props) => ({
      groupModalVisibile: false,
    }));
  };
  render() {
    const {
      width,
      collapsed,
      collapsible,
      logo,
      // title,
      onCollapse,
      siteLanguage,
      location,
      addGroup,
      intl,
      userId,
      addingGroup,
      groupCreated,
      numberOfGroups,
      // numberOfPeople,
      totalNumberOfPeople,
      groups,
      systemGroups,
      handelDeleteGroup,
    } = this.props;

    const {
      groupModalVisibile,
      groupFormTitle,
      groupFormData,
      groupFormStatus,
    } = this.state;

    return (
      <React.Fragment>
        <Layout.Sider
          breakpoint="md"
          onCollapse={onCollapse}
          collapsed={collapsed}
          collapsible={collapsible}
          width={width}
          className={styles.sider}
        >
          <Menu
            selectable={false}
            className={styles.menu}
            theme="light"
            defaultSelectedKeys={[`/${siteLanguage || "en"}/`]}
            selectedKeys={[location.pathname]}
          >
            <Menu.Item title="Add a new group" key="open-create-group-modal">
              <Icon type="plus" />
              <span>
                <FormattedMessage
                  id="CreateGroup"
                  defaultMessage="Create group"
                />
              </span>
              <Link
                to="#"
                onClick={(e) =>
                  this.setState(
                    (state, props) => ({
                      groupFormTitle: props.intl.formatMessage(
                        cw["CreateGroup"]
                      ),
                      groupFormData: { name: "" },
                      groupFormStatus: "create",
                    }),
                    () => {
                      this.handleCreateGroupButtonClick(e);
                    }
                  )
                }
              />
            </Menu.Item>
            <Menu.Divider className={styles.divider} />
            <Menu.Item
              className={styles.mainMenu}
              key={`/${siteLanguage || "en"}/everyone`}
            >
              <Icon component={PersonIcon} />
              <span>
                <FormattedMessage id="Everyone" defaultMessage="Everyone" />
              </span>
              <span className={styles.groupRightIcons}>
                {totalNumberOfPeople === 0
                  ? null
                  : parseInt(totalNumberOfPeople).toLocaleString()}
              </span>
              <Link
                data-dfs-people-id={"main-menu-item-everyone"}
                to={`/${siteLanguage || "en"}/everyone`}
              />
            </Menu.Item>
            {systemGroups.map((item) => {
              if (item.person_count < 1) return null;
              return (
                <Menu.Item
                  className={styles.mainMenu}
                  key={`/${siteLanguage || "en"}/groups/${item.uuid}`}
                >
                  <Icon style={{ fontSize: 18 }} type="solution" />
                  <span>{intl.formatMessage(cw[item.name])}</span>
                  <span className={styles.groupRightIcons}>
                    {item.person_count}
                  </span>
                  <Link
                    data-dfs-people-id={"main-menu-item-system"}
                    to={`/${siteLanguage || "en"}/groups/${item.uuid}`}
                  />
                </Menu.Item>
              );
            })}
            <Menu.Divider className={styles.divider} />
            {groups.map((group, index) => (
              <Menu.Item
                key={`/${siteLanguage || "en"}/groups/${group.uuid}`}
                className="groupsListMenu"
              >
                {/* <img
                  style={{ width: 13, marginRight: 10 }}
                  alt="grayed icon"
                  src={GrayedGroupIcon}
                /> */}
                {/* <Icon /> */}
                <span data-dfs-people-id={`main-menu-item-name-${group.name}`}>
                  {group.name}
                </span>
                <Link
                  style={{ display: "inline-block" }}
                  data-dfs-people-id={`main-menu-item-link-${group.name}`}
                  to={`/${siteLanguage || "en"}/groups/${group.uuid}`}
                />
                <span className={styles.groupRightIcons}>
                  <span
                    className={classnames("unhidden", "groupItem")}
                    data-dfs-people-id={`group-person-count-${group.uuid}`}
                  >
                    {group.person_count === "0"
                      ? null
                      : parseInt(group.person_count).toLocaleString()}
                  </span>
                  <span className={classnames("hidden", "groupItem")}>
                    <img
                      alt="Edit"
                      style={{ marginRight: 10, width: 12 }}
                      // type="edit"
                      src={EditIcon}
                      onClick={(e) => {
                        this.setState(
                          {
                            groupFormTitle: "Edit group name",
                            groupFormStatus: "edit",
                          },
                          () => {
                            this.handleCreateGroupButtonClick(e, group);
                          }
                        );
                      }}
                    />
                    <img
                      style={{ marginRight: 0, width: 12 }}
                      // theme="filled"
                      type="delete"
                      alt="Delete"
                      src={DeleteIcon}
                      onClick={(e) => {
                        Modal.confirm({
                          centered: true,
                          title: this.props.intl.formatMessage(
                            cw["DeleteGroup"]
                          ),
                          content: this.props.intl.formatMessage(
                            cw["DeleteGroupMessage"]
                          ),
                          okText: this.props.intl.formatMessage(cw["delete"]),
                          okType: "primary",
                          cancelText: this.props.intl.formatMessage(
                            cw["cancel"]
                          ),
                          // onOk: e => {

                          // },
                          onOk() {
                            handelDeleteGroup(group);
                            // return false;
                          },
                          onCancel() {
                            return false;
                          },
                        });
                      }}
                    />
                  </span>
                </span>
              </Menu.Item>
            ))}
          </Menu>
        </Layout.Sider>

        <GroupForm
          title={groupFormTitle}
          handleCloseModal={this.handleCloseGroupFormModal}
          visible={groupModalVisibile}
          intl={intl}
          siteLanguage={siteLanguage}
          onSubmit={addGroup}
          userId={userId}
          addingGroup={addingGroup}
          groupCreated={groupCreated}
          data={groupFormData}
          groupFormStatus={groupFormStatus}
        />
      </React.Fragment>
    );
  }
}

export default Sider;
